import { FC } from 'react';
import { SMPFlex, SMPText } from '../../../../index';

export interface IKnockoutHeadProps {
  name: string;
  isMobile?: boolean;
}

export const KnockoutHead: FC<IKnockoutHeadProps> = ({ name, isMobile }): JSX.Element => {
  return (
    <SMPFlex
      css={{
        width: '100%',
        py: '$3',
        px: '$3',
        borderRadius: '$2',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: isMobile ? '$knockoutHeaderBgColor' : undefined,
        border: isMobile ? '1px solid $knockoutHeaderBorderColor' : undefined,
      }}
    >
      <SMPText css={{ textAlign: 'center', width: '100%' }} variant='contrast' size='3' weight='700'>
        {name}
      </SMPText>
    </SMPFlex>
  );
};
